module.exports = __webpack_public_path__ + "media/images/logos/split-shipment-icon-b8f0a9f410e8d277420e19662ad0ea5d.gif";